import Check from "../../icons/Check";

interface FilterCheckboxProps {
  selected: boolean,
  paramLabel: string;
  index: number
}

const FilterCheckbox: React.FC<FilterCheckboxProps> = ({selected, paramLabel, index}) => { 
  return   <div className="w-10 h-8">
    <input
      type="checkbox"
      className="w-10 h-10 opacity-0"
      name={`${paramLabel}${index}`}
    />
    <div
      className={`${selected && 'bg-primary'} ${selected ? 'border-primary' : 'border-gray7'
        } 
      absolute  rounded-sm h-5 w-5 border-solid border-2 top-2 left-2
      `}
    >
      {selected && (
        <Check className="absolute w-4 h-4 text-white inset" />
      )}
    </div>
  </div>
 
  
}; 

export default FilterCheckbox;